import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const Alumi = () => {
  return (
    <div>
      <Container>
        <Row>
          <Col>
          </Col>
        </Row>
      </Container>
      
    </div>
  )
}

export default Alumi